import React from 'react';
import '../../styles/FeedbackPage.css';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

const feedbackData = [
  {
    title: 'Student Feedback',
    description: 'We value student perspectives to continuously enhance the learning environment.',
    link: '/feedback/student.pdf',
  },
  {
    title: 'Teacher Feedback',
    description: 'Faculty members contribute feedback for curriculum and teaching improvements.',
    link: '/feedback/teacher.pdf',
  },
  {
    title: 'Alumni Feedback',
    description: 'Alumni share insights based on real-world experiences for curriculum upgrades.',
    link: '/feedback/alumni.pdf',
  },
  {
    title: 'Employer Feedback',
    description: 'Employers provide feedback on graduate performance and industry readiness.',
    link: '/feedback/employer.pdf',
  },
];

const FeedbackPage = () => {
  return (
    <>
      <Navbar />
      <section className="feedback-page fade-in">
        <div className="feedback-page-container">
          <h1 className="feedback-title">Feedback</h1>
          <p className="feedback-subtitle">Your opinions matter in shaping our academic excellence.</p>
          <div className="feedback-cards">
            {feedbackData.map((item, index) => (
              <div className="feedback-card" key={index}>
                <h2>{item.title}</h2>
                <p>{item.description}</p>
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learn more →
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default FeedbackPage;
